import * as React from 'react';
import {forwardRef, FunctionComponent} from 'react';
import {ReactSortable} from 'react-sortablejs';
import {TrainingPlan} from '../../models/TrainingPlan';

interface OwnProps {
    trainingPlans: TrainingPlan[];
    onOrderChange: (trainingPlans: TrainingPlan[]) => void;
    children: (trainingPlan: TrainingPlan, index: number) => React.ComponentElement<any, any>;
}

const ListComponent = forwardRef<HTMLDivElement, any>((props, ref) => {
    return (
        <div className="training-plan-element-selector__selected-list" ref={ref}>
            {props.children}
        </div>
    );
});

export const SelectedList: FunctionComponent<OwnProps> = ({trainingPlans, onOrderChange, children}) => {
    return (
        <ReactSortable
            tag={ListComponent}
            list={trainingPlans.map((item) => ({
                id: item.id,
                item: item,
            }))}
            setList={(list) => onOrderChange(list.map((item) => item.item))}
        >
            {trainingPlans.map((trainingPlan, index) => {
                return (
                    <div key={trainingPlan.id} className="training-plan-element-selector__selected-list-item">
                        <span className="training-plan-element-selector__selected-list-item-handle ion-md-reorder" />
                        {children(trainingPlan, index)}
                    </div>
                );
            })}
        </ReactSortable>
    );
};
